export const GET_ALL_HELPCENTER_STARTED = "GET_ALL_HELPCENTER_STARTED";
export const GET_ALL_HELPCENTER_SUCCESS = "GET_ALL_HELPCENTER_SUCCESS";
export const GET_ALL_HELPCENTER_FAILURE = "GET_ALL_HELPCENTER_FAILURE";

export const CONTACTUS_STARTED = "CONTACTUS_STARTED";
export const CONTACTUS_SUCCESS = "CONTACTUS_SUCCESS";
export const CONTACTUS_FAILURE = "CONTACTUS_FAILURE";